import PageNotFound from "../pages/PageNotFoud";
import People from "../pages/people/people";
import Customfields from "../pages/infofields/infofields";
import Profile from "../pages/profile/profile";
import Siteconfiguration from "../pages/SiteConfiguration/siteconfiguration";
import Peopleprofile from "../pages/people/people-profile";
//import { Timeshift } from "../pages/timeshift/timeshift";
import Timesheet from "../pages/timesheet/timesheet";
import Facility from "../pages/facility/facility";
import Wards from "../pages/wards/wards";
import NewSchedule from "../pages/NewSchedule/NewSchedule";
import DashboardNew from "../pages/Dashboard/DashboardNew";
import Worktype from "../pages/Worktype/Worktype";

const routes = [
  {
    path: "/dashboard",
    element: DashboardNew,
    name: "Dashboard",
    breadcrumb: false,
  },
  {
    path: "/employee",
    element: People,
    name: "Employee List",
    breadcrumb: true,
  },
  {
    path: "/employee/profile/:id",
    element: Peopleprofile,
    name: "Peopleprofile",
  },
  {
    path: "/facility",
    element: Facility,
    name: "Facility List",
    breadcrumb: true,
  },
  {
    path: "/subfacility",
    element: Wards,
    name: "Wards/Sub-wards",
    breadcrumb: true,
  },
  { path: "/infofield", element: Customfields, name: "Custom Fields" },
  { path: "/profile", element: Profile, name: "Profile" },
  { path: "/schedule", element: NewSchedule, name: "Schedule" },
  { path: "/config", element: Siteconfiguration, name: "Site Configuration" },
  //{ path: '/timeshift', element: Timeshift, name: 'Timeshift'},
  { path: "/timesheet", element: Timesheet, name: "Timesheet" },
  { path: "/worktype", element: Worktype, name: "Worktype" },

  { path: "*", element: PageNotFound, breadcrumb: false },
];

export default routes;
